export const enum ReferrerStatus {
    Expired = 'expired',
    Failed = 'failed'
};
